<template>
  <div>
    <OrderOnboarding v-if="shouldShowOnboarding" />
    <OrderDetails v-else />
  </div>
</template>

<script>
import OrderDetails from "@/components/Common/OrderDetails";
import OrderOnboarding from "@/components/Order/OrderOnboarding";

export default {
  components: {
    OrderDetails,
    OrderOnboarding
  },
  computed: {
    shouldShowOnboarding() {
      const store = this.$store.getters.getStore;
      return store.hasOrderNotificationEnabled === false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
